const API_CITY_BY_USER_CITY = {
  bangalore: "Bengaluru",
  bengaluru: "Bengaluru",
  "bangalore rural": "Bengaluru",
  "bangalore urban": "Bengaluru",
  "bengaluru rural": "Bengaluru",
  "bengaluru urban": "Bengaluru",
  bommanahalli: "Bengaluru",
  bommasandra: "Bengaluru",
  "btm layout": "Bengaluru",
  devanahalli: "Bengaluru",
  "electronic city": "Bengaluru",
  hebbal: "Bengaluru",
  "hsr layout": "Bengaluru",
  indiranagar: "Bengaluru",
  jayanagar: "Bengaluru",
  "kr puram": "Bengaluru",
  "krishnarajapuram": "Bengaluru",
  koramangala: "Bengaluru",
  marathahalli: "Bengaluru",
  "manyata tech park": "Bengaluru",
  rajajinagar: "Bengaluru",
  sarjapur: "Bengaluru",
  "sarjapur road": "Bengaluru",
  "yeshwanthpur": "Bengaluru",
  "yesvantpur": "Bengaluru",
  whitefield: "Bengaluru",
  yelahanka: "Bengaluru",

  chandigarh: "Chandigarh",
  "chandigarh capital region": "Chandigarh",
  "chandigarh tricity": "Chandigarh",
  derabassi: "Chandigarh",
  kharar: "Chandigarh",
  manimajra: "Chandigarh",
  mohali: "Chandigarh",
  "sas nagar": "Chandigarh",
  "sahibzada ajit singh nagar": "Chandigarh",
  panchkula: "Chandigarh",
  pinjore: "Chandigarh",
  zirakpur: "Chandigarh",

  chennai: "Chennai",
  ambattur: "Chennai",
  avadi: "Chennai",
  chengalpattu: "Chennai",
  "egmore": "Chennai",
  "guindy": "Chennai",
  kanchipuram: "Chennai",
  "kelambakkam": "Chennai",
  "madipakkam": "Chennai",
  "mahindra world city": "Chennai",
  "medavakkam": "Chennai",
  "mylapore": "Chennai",
  "nungambakkam": "Chennai",
  "omr": "Chennai",
  pallavaram: "Chennai",
  "porur": "Chennai",
  "sholinganallur": "Chennai",
  tambaram: "Chennai",
  "t nagar": "Chennai",
  "thoraipakkam": "Chennai",
  "velachery": "Chennai",
  tiruvallur: "Chennai",

  delhi: "Delhi NCR",
  "delhi ncr": "Delhi NCR",
  "central delhi": "Delhi NCR",
  "east delhi": "Delhi NCR",
  faridabad: "Delhi NCR",
  ghaziabad: "Delhi NCR",
  "greater noida": "Delhi NCR",
  gurgaon: "Delhi NCR",
  gurugram: "Delhi NCR",
  "new gurgaon": "Delhi NCR",
  noida: "Delhi NCR",
  "north delhi": "Delhi NCR",
  "north east delhi": "Delhi NCR",
  "north west delhi": "Delhi NCR",
  "old delhi": "Delhi NCR",
  "south delhi": "Delhi NCR",
  "south east delhi": "Delhi NCR",
  "south west delhi": "Delhi NCR",
  "west delhi": "Delhi NCR",

  goa: "Goa",
  anjuna: "Goa",
  arambol: "Goa",
  bardez: "Goa",
  bicholim: "Goa",
  canacona: "Goa",
  calangute: "Goa",
  candolim: "Goa",
  colva: "Goa",
  darbandora: "Goa",
  "dona paula": "Goa",
  madgaon: "Goa",
  mapusa: "Goa",
  margao: "Goa",
  mormugao: "Goa",
  "north goa": "Goa",
  "old goa": "Goa",
  panaji: "Goa",
  panjim: "Goa",
  ponda: "Goa",
  porvorim: "Goa",
  salcete: "Goa",
  sanguem: "Goa",
  "south goa": "Goa",
  siolim: "Goa",
  vagator: "Goa",
  vasco: "Goa",
  "vasco da gama": "Goa",

  hyderabad: "Hyderabad",
  ameerpet: "Hyderabad",
  "banjara hills": "Hyderabad",
  cyberabad: "Hyderabad",
  gachibowli: "Hyderabad",
  "hitec city": "Hyderabad",
  "jubilee hills": "Hyderabad",
  kondapur: "Hyderabad",
  kukatpally: "Hyderabad",
  madhapur: "Hyderabad",
  manikonda: "Hyderabad",
  "nanakramguda": "Hyderabad",
  "rangareddy": "Hyderabad",
  "ranga reddy": "Hyderabad",
  secunderabad: "Hyderabad",
  shamshabad: "Hyderabad",
  "sr nagar": "Hyderabad",
  uppal: "Hyderabad",

  kolkata: "Kolkata",
  alipore: "Kolkata",
  barrackpore: "Kolkata",
  barasat: "Kolkata",
  behala: "Kolkata",
  bidhannagar: "Kolkata",
  dumdum: "Kolkata",
  "dum dum": "Kolkata",
  esplanade: "Kolkata",
  garia: "Kolkata",
  hooghly: "Kolkata",
  howrah: "Kolkata",
  jadavpur: "Kolkata",
  "new town": "Kolkata",
  "park street": "Kolkata",
  rajarhat: "Kolkata",
  "salt lake": "Kolkata",
  serampore: "Kolkata",
  sealdah: "Kolkata",
  "south dumdum": "Kolkata",

  mumbai: "Mumbai",
  andheri: "Mumbai",
  ambernath: "Mumbai",
  badlapur: "Mumbai",
  bandra: "Mumbai",
  bhiwandi: "Mumbai",
  borivali: "Mumbai",
  byculla: "Mumbai",
  chembur: "Mumbai",
  dadar: "Mumbai",
  dombivli: "Mumbai",
  ghatkopar: "Mumbai",
  goregaon: "Mumbai",
  jogeshwari: "Mumbai",
  juhu: "Mumbai",
  kalyan: "Mumbai",
  kandivali: "Mumbai",
  khar: "Mumbai",
  kurla: "Mumbai",
  "lower parel": "Mumbai",
  malad: "Mumbai",
  "mira bhayandar": "Mumbai",
  mulund: "Mumbai",
  "navi mumbai": "Mumbai",
  panvel: "Mumbai",
  powai: "Mumbai",
  santacruz: "Mumbai",
  thane: "Mumbai",
  ulhasnagar: "Mumbai",
  vasai: "Mumbai",
  "vasai-virar": "Mumbai",
  vikhroli: "Mumbai",
  "vile parle": "Mumbai",
  virar: "Mumbai",
  wadala: "Mumbai",
  worli: "Mumbai",

  "new delhi": "New Delhi",
  "connaught place": "New Delhi",
  chanakyapuri: "New Delhi",
  dwarka: "New Delhi",
  "greater kailash": "New Delhi",
  "hauz khas": "New Delhi",
  "karol bagh": "New Delhi",
  "lajpat nagar": "New Delhi",
  "lutyens delhi": "New Delhi",
  "new delhi district": "New Delhi",
  "patel nagar": "New Delhi",
  "rajouri garden": "New Delhi",
  saket: "New Delhi",
  "vasant kunj": "New Delhi",

  pune: "Pune",
  aundh: "Pune",
  baner: "Pune",
  bavdhan: "Pune",
  chakan: "Pune",
  dhanori: "Pune",
  fursungi: "Pune",
  hadapsar: "Pune",
  hinjewadi: "Pune",
  hinjawadi: "Pune",
  "kalyani nagar": "Pune",
  kharadi: "Pune",
  "koregaon park": "Pune",
  magarpatta: "Pune",
  nigdi: "Pune",
  "pimple saudagar": "Pune",
  pimpri: "Pune",
  "pimpri-chinchwad": "Pune",
  "pimpri chinchwad": "Pune",
  ravet: "Pune",
  shivajinagar: "Pune",
  swargate: "Pune",
  talegaon: "Pune",
  "viman nagar": "Pune",
  wagholi: "Pune",
  wakad: "Pune",

  dehradun: "Dehradun",
  guwahati: "Guwahati",
  gauhati: "Guwahati",
  indore: "Indore",
  jaipur: "Jaipur",
  kochi: "Kochi",
  cochin: "Kochi",
  ernakulam: "Kochi",
};

const AVAILABLE_API_CITIES = new Set(
  [
    "Bengaluru",
    "Chandigarh",
    "Chennai",
    "Dehradun",
    "Delhi NCR",
    "Goa",
    "Guwahati",
    "Hyderabad",
    "Indore",
    "Jaipur",
    "Kochi",
    "Kolkata",
    "Mumbai",
    "New Delhi",
    "Pune",
  ].map((city) => city.toLowerCase())
);

const normalizeCityName = (city) => `${city ?? ""}`.trim();

const normalizeCityKey = (city) =>
  normalizeCityName(city)
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

export const resolveApiCity = (city) => {
  const normalizedCity = normalizeCityName(city);

  return API_CITY_BY_USER_CITY[normalizeCityKey(normalizedCity)] || normalizedCity;
};

export const isKnownApiCity = (city) =>
  AVAILABLE_API_CITIES.has(normalizeCityKey(city));

export const resolveKnownApiCity = (city) => {
  const resolvedCity = resolveApiCity(city);

  return isKnownApiCity(resolvedCity) ? resolvedCity : "";
};

export const resolveUserBaseCity = (...cities) => {
  for (const city of cities) {
    const normalizedCity = normalizeCityName(city);

    if (normalizedCity) {
      return normalizedCity;
    }
  }

  return "";
};

const collectItemCityCandidates = (item) => {
  if (!item || typeof item !== "object") return [];

  const club =
    item.club && typeof item.club === "object"
      ? item.club
      : item.clubId && typeof item.clubId === "object"
        ? item.clubId
        : {};
  const venue = item.venue && typeof item.venue === "object" ? item.venue : {};
  const address = item.address && typeof item.address === "object" ? item.address : {};
  const location = item.location && typeof item.location === "object" ? item.location : {};
  const clubAddress =
    club.address && typeof club.address === "object" ? club.address : {};

  return [
    item.city,
    address.city,
    location.city,
    address.town,
    club.city,
    clubAddress.city,
    venue.city,
    item.locality,
    address.locality,
    location.locality,
    club.locality,
    venue.locality,
    item.fullAddress,
    address.fullAddress,
    club.fullAddress,
  ]
    .flatMap((value) => `${value ?? ""}`.split(/[,|/]/))
    .map((value) => value.trim())
    .filter(Boolean);
};

export const itemBelongsToSelectedCity = (item, selectedCity) => {
  const targetCity = resolveApiCity(selectedCity);
  if (!targetCity) return true;

  const targetKey = normalizeCityKey(targetCity);
  const knownCities = new Set();

  collectItemCityCandidates(item).forEach((candidate) => {
    const knownCity = resolveKnownApiCity(candidate);
    if (knownCity) {
      knownCities.add(normalizeCityKey(knownCity));
    }
    if (normalizeCityKey(candidate) === targetKey) {
      knownCities.add(targetKey);
    }
  });

  if (knownCities.size) {
    return knownCities.has(targetKey);
  }

  return true;
};

export const resolveAvailableCity = (city, availableCities = []) => {
  const normalizedCity = normalizeCityName(city);
  if (!normalizedCity) return null;

  const findAvailableCity = (cityName) =>
    availableCities.find(
      (item) => normalizeCityKey(item?.name) === normalizeCityKey(cityName)
    );

  const exactMatch = findAvailableCity(normalizedCity);
  if (exactMatch) return exactMatch;

  const apiCity = resolveApiCity(normalizedCity);

  return findAvailableCity(apiCity) || null;
};
